export const FETCH_TAXENTITYLIST_BEGIN = "FETCH_TAXENTITYLIST_BEGIN";
export const FETCH_TAXENTITYLIST_SUCCESS = "FETCH_TAXENTITYLIST_SUCCESS";
export const FETCH_TAXENTITYLIST_FAILURE = "FETCH_TAXENTITYLIST_FAILURE";



export const FETCH_TAXENTITYDETAIL_BEGIN = "FETCH_TAXENTITYDETAIL_BEGIN";
export const FETCH_TAXENTITYDETAIL_SUCCESS = "FETCH_TAXENTITYDETAIL_SUCCESS";
export const FETCH_TAXENTITYDETAIL_FAILURE = "FETCH_TAXENTITYDETAIL_FAILURE";

export const FETCH_INVESTORACTIVITYDETAIL_BEGIN = "FETCH_INVESTORACTIVITYDETAIL_BEGIN";
export const FETCH_INVESTORACTIVITYDETAIL_SUCCESS = "FETCH_INVESTORACTIVITYDETAIL_SUCCESS";
export const FETCH_INVESTORACTIVITYDETAIL_FAILURE = "FETCH_INVESTORACTIVITYDETAIL_FAILURE";

export const FETCH_RELATEDCONTACT_BEGIN = "FETCH_RELATEDCONTACT_BEGIN";
export const FETCH_RELATEDCONTACT_SUCCESS = "FETCH_RELATEDCONTACT_SUCCESS";
export const FETCH_RELATEDCONTACT_FAILURE = "FETCH_RELATEDCONTACT_FAILURE";

export const FETCH_RELATIONTYPES_BEGIN = "FETCH_RELATIONTYPES_BEGIN";
export const FETCH_RELATIONTYPES_SUCCESS = "FETCH_RELATIONTYPES_SUCCESS";
export const FETCH_RELATIONTYPES_FAILURE = "FETCH_RELATIONTYPES_FAILURE";